import { Link } from "react-router-dom";
import { useLayoutEffect, useRef, useState } from "react";

const PricingCards = ({ pricingPlans, backgroundClass = "bg-light" }) => {
  const titleRefs = useRef([]);
  const subtitleRefs = useRef([]);
  const [titleHeight, setTitleHeight] = useState("auto");
  const [subtitleHeight, setSubtitleHeight] = useState("auto");

  useLayoutEffect(() => {
    const measure = () => {
      // reset first so we measure natural (unstretched) height
      setTitleHeight("auto");
      setSubtitleHeight("auto");

      requestAnimationFrame(() => {
        const tallestTitle = Math.max(
          ...titleRefs.current.filter(Boolean).map((el) => el.offsetHeight)
        );
        const tallestSubtitle = Math.max(
          ...subtitleRefs.current.filter(Boolean).map((el) => el.offsetHeight)
        );
        setTitleHeight(`${tallestTitle}px`);
        setSubtitleHeight(`${tallestSubtitle}px`);
      });
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [pricingPlans]);

  return (
    <section className={`py-5 ${backgroundClass}`}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Vehicle Inspection Services</h2>
          <p className="text-muted mb-0">
            Online inspections for rideshare and car share drivers, plus comprehensive on-site pre-purchase inspections.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {pricingPlans.map((plan, i) => (
            <div className="col-md-6 col-lg-3" key={plan.title}>
              <div
                className={`card h-100 border-0 shadow-sm rounded-4 ${
                  plan.featured ? "border border-primary border-2" : ""
                }`}
              >
                {plan.featured && (
                  <div className="badge bg-primary position-absolute top-0 start-50 translate-middle px-3 py-2 rounded-pill">
                    Most Popular
                  </div>
                )}

                <div className="card-body p-4 p-lg-5 d-flex flex-column text-center">
                  <h4
                    ref={(el) => (titleRefs.current[i] = el)}
                    className="fw-bold mb-2"
                    style={{
                      height: titleHeight,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {plan.title}
                  </h4>

                  <p
                    ref={(el) => (subtitleRefs.current[i] = el)}
                    className="text-muted mb-4"
                    style={{
                      height: subtitleHeight,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {plan.subtitle}
                  </p>

                  <div className="mb-4">
                    <span className="display-5 fw-bold">{plan.price}</span>
                  </div>
                  <Link
                    className="btn mt-auto py-3 rounded-3 fw-semibold btn-outline-primary"
                    target={plan.externalUrl ? "_blank" : "_self"}
                    to={plan.externalUrl ? plan.externalUrl : "quotation"}
                  >
                    {plan.button}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingCards;